import apiClient from '@/lib/api-client';
import { ApiError } from '@/model/ApiError';
import { Module, Mutation, VuexModule, Action } from 'vuex-module-decorators';
import {
    PasswordFormData,
    ProfileFormData,
    ProfileResponse,
    User,
} from '@/model/Profile';
import store from '..';

@Module({ namespaced: true })
export default class ProfileStorage extends VuexModule {
    errorProfile: ApiError | null = null;

    errorPassword: ApiError | null = null;

    profile: User | null = null;

    @Mutation
    setErrorProfile(errorProfile: ApiError | null): void {
        this.errorProfile = errorProfile;
    }

    @Mutation
    setErrorPassword(errorPassword: ApiError | null): void {
        this.errorPassword = errorPassword;
    }

    @Mutation
    setProfile(profile: User | null): void {
        this.profile = profile;
    }

    @Mutation
    setProfileFirstNameLastNamePhone(formData: ProfileFormData): void {
        if (this.profile) {
            this.profile.firstName = formData.firstName;
            this.profile.lastName = formData.lastName;
            this.profile.phone = formData.phone;
        }
    }

    @Action
    updateProfile(formData: ProfileFormData): Promise<void> {
        return apiClient
            .put(`/users/${this.profile?.id}`, formData)
            .then(() => {
                this.context.commit('setErrorProfile', null);
                this.context.commit(
                    'setProfileFirstNameLastNamePhone',
                    formData,
                );
                store.commit(
                    'authenticationStorage/setUserFirstNameLastNamePhone',
                    formData,
                );

                return Promise.resolve();
            })
            .catch((error) => {
                this.context.commit('setErrorProfile', error);
                return Promise.reject();
            });
    }

    @Action
    updatePassword(formData: PasswordFormData): Promise<void> {
        return apiClient
            .put(`/users/${this.profile?.id}/password`, formData)
            .then(() => {
                this.context.commit('setErrorPassword', null);
                this.context.commit(
                    'authenticationStorage/setCredential',
                    null,
                    { root: true },
                );
                return Promise.resolve();
            })
            .catch((error) => {
                const errorTemp = {
                    key: error.key,
                    validationMessages: {
                        oldPassword: 'validation.user.wrong-password',
                    },
                };
                this.context.commit('setErrorPassword', errorTemp);
                return Promise.reject();
            });
    }

    @Action
    fetchProfile(): Promise<User> {
        return new Promise((resolve, reject) => {
            apiClient
                .get('/users/me')
                .then((response) => {
                    this.context.commit('setErrorProfile', null);
                    this.context.commit('setErrorPassword', null);
                    this.context.commit('setProfile', response);
                    resolve(response.data);
                })
                .catch((error) => {
                    this.context.commit('setErrorProfile', error);
                    reject(error.response.data);
                });
        });
    }

    get getErrorProfile(): ApiError | null {
        return this.errorProfile;
    }

    get getErrorPassword(): ApiError | null {
        return this.errorPassword;
    }

    get getProfile(): ProfileResponse | null {
        return this.profile;
    }
}
